export enum FilterOrientationEnum {
  left = 'left',
  middle = 'middle',
  right = 'right',
}
